const PlaqueStructure = (event) => {

    let check = true;
    if (event.key != 'Backspace' && (event.target.value.length === 3 && check === true)){
        check = false;
        return event.target.value += '-';
    }

}
export default PlaqueStructure;